import { AsyncPipe, Location, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { I18NEXT_SERVICE, I18NextModule, ITranslationService } from 'angular-i18next';
import { map, Observable, tap } from 'rxjs';
import { BigCardComponent } from 'src/app/_shared/components/big-card/big-card.component';
import { BottomBarComponent } from 'src/app/_shared/components/bottom-bar/bottom-bar.component';
import { ContactUsButtonComponent } from 'src/app/_shared/components/contact-us-button/contact-us-button.component';
import { CardContentSharryFragment } from 'src/app/common/fragments/card-content.fragment.generated';
import { GiftCardBannerComponent } from 'src/app/_shared/components/gift-card-banner/gift-card-banner.component';
import { GoldenCarouselComponent } from 'src/app/_shared/components/golden-carousel/golden-carousel.component';
import { GtagService } from 'src/app/common/gtag/gtag.service';
import { HeaderComponent } from 'src/app/_shared/components/header/header.component';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { METADATA_SERVICE, MetadataService } from 'src/app/common/metadata/metadata.service';
import { OpenDialogService } from 'src/app/common/open-dialog/open-dialog.service';
import { environment } from 'src/environments/environment';
import { Category } from 'src/types/graphql';
import { FooterComponent } from '../../_shared/components/footer/footer.component';
import { ClaimContentsGQL, SoldBySharrylandCategoriesGQL } from './trip.query.generated';
import { RouteTranslatePipe } from '../../_shared/pipes/route-translate.pipe';
import { CardCarouselComponent } from '../../_shared/components/card-carousel/card-carousel.component';

@Component({
  selector: 'sharry-trip',
  standalone: true,
  templateUrl: './trip.component.html',
  styleUrl: './trip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgStyle,
    BottomBarComponent,
    MatExpansionModule,
    IconComponent,
    I18NextModule,
    HeaderComponent,
    BigCardComponent,
    MatButtonModule,
    AsyncPipe,
    RouterLink,
    RouteTranslatePipe,
    GoldenCarouselComponent,
    FooterComponent,
    GiftCardBannerComponent,
    ContactUsButtonComponent,
    CardCarouselComponent,
  ],
})
export class TripComponent {
  private env = environment.env;
  currentLanguage = '';
  showBannerTripBusiness = environment.showBannerTripBusiness;
  heroImages = [
    {
      ['480']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/1-480.webp`,
      ['768']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/1-768.webp`,
      ['1024']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/1-1024.webp`,
      ['1440']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/1-1440.webp`,
      ['1920']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/1-1920.webp`,
      title: 'trip.claim.hero-title-0',
      subtitle: 'trip.claim.hero-subtitle-0',
      textColor: '#fff',
    },
    {
      ['480']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/2-480.webp`,
      ['768']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/2-768.webp`,
      ['1024']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/2-1024.webp`,
      ['1440']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/2-1440.webp`,
      ['1920']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/2-1920.webp`,
      title: 'trip.claim.hero-title-1',
      subtitle: 'trip.claim.hero-subtitle-1',
      textColor: '#fff',
    },
    {
      ['480']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/3-480.webp`,
      ['768']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/3-768.webp`,
      ['1024']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/3-1024.webp`,
      ['1440']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/3-1440.webp`,
      ['1920']: `https://media.sharry.land/app/images/hero/${
        this.env === 'production' ? 'production' : 'staging'
      }/trip/3-1920.webp`,
      title: 'trip.claim.hero-title-2',
      subtitle: 'trip.claim.hero-subtitle-2',
      textColor: '#fff',
    },
    // {
    //   ['480']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/4-480.webp`,
    //   ['768']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/4-768.webp`,
    //   ['1024']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/4-1024.webp`,
    //   ['1440']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/4-1440.webp`,
    //   ['1920']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/4-1920.webp`,
    //   title: 'trip.claim.hero-title-3',
    //   subtitle: 'trip.claim.hero-subtitle-3',
    //   textColor: '#fff',
    // },
    // {
    //   ['480']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/5-480.webp`,
    //   ['768']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/5-768.webp`,
    //   ['1024']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/5-1024.webp`,
    //   ['1440']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/5-1440.webp`,
    //   ['1920']: `https://media.sharry.land/app/images/hero/${
    //     this.env === 'production' ? 'production' : 'staging'
    //   }/trip/5-1920.webp`,
    //   title: 'trip.claim.hero-title-4',
    //   subtitle: 'trip.claim.hero-subtitle-4',
    //   textColor: '#fff',
    // },
  ];
  listITalydivided = [
    {
      title: 'trip.where.all',
      img: 'all',
      queryParams: {
        value: 'i viaggi di sharryland',
        prefix: 'title',
        soldBySharryland: true,
        ignoreValue: true,
      },
    },
    {
      title: 'trip.where.north',
      img: 'nord',
      queryParams: {
        value: 'i viaggi di sharryland',
        prefix: 'title',
        soldBySharryland: true,
        ignoreValue: true,
        regions: [
          "Valle d'Aosta",
          'Piemonte',
          'Liguria',
          'Lombardia',
          'Friuli-Venezia Giulia',
          'Trentino-Alto Adige',
          'Veneto',
          'Emilia-Romagna',
        ],
      },
    },
    {
      title: 'trip.where.center',
      img: 'centro',
      queryParams: {
        value: 'i viaggi di sharryland',
        prefix: 'title',
        soldBySharryland: true,
        ignoreValue: true,
        regions: ['Lazio', 'Marche', 'Umbria', 'Toscana', 'Abruzzo'],
      },
    },
    {
      title: 'trip.where.south',
      img: 'sud',
      queryParams: {
        value: 'i viaggi di sharryland',
        prefix: 'title',
        soldBySharryland: true,
        ignoreValue: true,
        regions: ['Molise', 'Puglia', 'Basilicata', 'Calabria', 'Campania', 'Sicilia', 'Sardegna'],
      },
    },
  ];

  listBaloons = [
    /*    {
      id: 0,
      img: 'https://media.sharry.land/app/images/trip/baloons/speciale-veneto.webp',
      title: 'trip.baloon.0',
      search: 'viaggi_in_veneto',
    },
    {
      id: 1,
      img: 'https://media.sharry.land/app/images/trip/baloons/tutti-i-viaggi.webp',
      title: 'trip.categories.all',
      search: 'tuttiviaggi_sharrytour',
    },*/
    {
      id: 7,
      img: 'https://media.sharry.land/app/images/trip/baloons/in-giornata.webp',
      title: 'trip.baloon.7',
      search: 'giornata_weekend_sharrytour',
    },
    {
      id: 8,
      img: 'https://media.sharry.land/app/images/trip/baloons/più-giorni.webp',
      title: 'trip.baloon.8',
      search: 'piu_giorni_sharrytour',
    },
    {
      id: 2,
      img: 'https://media.sharry.land/app/images/trip/baloons/storia-arte.webp',
      title: 'trip.baloon.1',
      search: 'storiaarte_sharrytour',
    },
    {
      id: 3,
      img: 'https://media.sharry.land/app/images/trip/baloons/buongustaio.webp',
      title: 'trip.baloon.2',
      search: 'buongustaio_sharrytour',
    },
    {
      id: 4,
      img: 'https://media.sharry.land/app/images/trip/baloons/outdoor.webp',
      title: 'trip.baloon.3',
      search: 'outdoor_sharrytour',
    },
    {
      id: 5,
      img: 'https://media.sharry.land/app/images/trip/baloons/borghi.webp',
      title: 'trip.baloon.4',
      search: 'borghi_sharrytour',
    },
    // {
    //   id: 5,
    //   img: 'https://media.sharry.land/app/images/trip/baloons/arti-mestieri.webp',
    //   title: 'trip.baloon.5',
    //   search: 'Arti_mestieri_sharrytour',
    // },
    // {
    //   id: 6,
    //   img: 'https://media.sharry.land/app/images/trip/baloons/benessere.webp',
    //   title: 'trip.baloon.6',
    //   search: 'Benessere_sharrytour',
    // },
  ];

  goldenBoxes = [
    {
      icon: 'ic-parla-con-noi',
      type: 'custom',
      title: 'golden-carousel.box-1.title',
      subtitle: 'golden-carousel.box-1.subtitle',
      button: 'golden-carousel.box-1.button',
    },
    {
      icon: 'star',
      type: 'custom',
      title: 'golden-carousel.box-2.title',
      subtitle: 'golden-carousel.box-2.subtitle',
    },
    {
      icon: 'sketch-logo',
      type: 'phosphor',
      title: 'golden-carousel.box-3.title',
      subtitle: 'golden-carousel.box-3.subtitle',
    },
    // {
    //   icon: 'certificate',
    //   type: 'phosphor',
    //   title: 'golden-carousel.box-4.title',
    //   subtitle: 'golden-carousel.box-4.subtitle',
    // },
    {
      icon: 'hand-heart',
      type: 'phosphor',
      title: 'golden-carousel.box-5.title',
      subtitle: 'golden-carousel.box-5.subtitle',
    },
    // {
    //   icon: 'file-plus',
    //   type: 'phosphor',
    //   title: 'golden-carousel.box-6.title',
    //   subtitle: 'golden-carousel.box-6.subtitle',
    //   anchor: 'golden-carousel.box-6.anchor',
    // },
    // {
    //   icon: 'rainbow',
    //   type: 'phosphor',
    //   title: 'golden-carousel.box-7.title',
    //   subtitle: 'golden-carousel.box-7.subtitle',
    // },
  ];

  public claimContents$: Observable<CardContentSharryFragment[]>;
  public soldBySharrylandCategories$: Observable<Partial<Category>[]>;
  tripSelectionList = signal<TripSelection[]>([]);

  constructor(
    @Inject(I18NEXT_SERVICE) private translateService: ITranslationService,
    private claimContentsGQL: ClaimContentsGQL,
    private soldBySharrylandCategoriesGQL: SoldBySharrylandCategoriesGQL,
    private openDialogService: OpenDialogService,
    @Inject(METADATA_SERVICE) private metadataService: MetadataService,
    private location: Location,
    private gtagService: GtagService,
  ) {
    this.metadataService.setMetadataPage('trip', this.location.path());
    this.currentLanguage = this.translateService.language;
    this.claimContents$ = this.claimContentsGQL.fetch({ hasDiscounts: true, limit: 8 }).pipe(
      map(r => r.data.allSharries),
      tap(cards => {
        const items = cards.map((card: any) => ({
          item_name: card?.title,
          item_id: card?.id,
          ...(card?.contentType === 'sharry' && { price: card?.nextUpcomingVariant?.discountedPrice }),
          item_brand: card?.owner?.businessName,
          item_category: card?.sharryKind?.name,
          item_variant: card?.sharrySelection,
        }));
        this.gtagService.pushEvent(
          {
            event: 'view_item_list',
            ecommerce: {
              items: items,
            },
          },
          true,
        );
      }),
    );
    this.claimContentsGQL
      .fetch({ hasDiscounts: false })
      .pipe(map(r => r.data.allSharries))
      .subscribe((res: CardContentSharryFragment[]) => {
        if (res) {
          const groupedArray: TripSelection[] = this.groupTripByKind(res);
          this.tripSelectionList.set(groupedArray);
        }
      });
    this.soldBySharrylandCategories$ = this.soldBySharrylandCategoriesGQL
      .fetch()
      .pipe(
        map(r => [
          { __typename: 'Category', id: '-1', hasSharrySoldBySharryland: true, name: 'all', normalizedName: 'all' },
          ...r.data.allCategories.filter(c => c.hasSharrySoldBySharryland),
        ]),
      );
  }

  private groupTripByKind = (res: CardContentSharryFragment[]) => {
    const groupedArray: TripSelection[] = Object.values(
      res.reduce(
        (acc, item) => {
          const kindName = item.sharryKind.name;
          if (!acc[kindName]) {
            acc[kindName] = { name: kindName, cards: [] };
          }
          acc[kindName].cards.push(item);
          return acc;
        },
        {} as Record<string, { name: string; cards: CardContentSharryFragment[] }>,
      ),
    );
    return groupedArray;
  };

  openDiscountsModal(): void {
    import('../../_shared/dialogs/available-discounts-dialog/available-discounts-dialog.component').then(
      ({ AvailableDiscountsDialogComponent }) =>
        this.openDialogService.openDialog(AvailableDiscountsDialogComponent, {
          ...{
            autoFocus: false,
            restoreFocus: false,
            minWidth: '50vw',
            maxHeight: '84vh',
          },
        }),
    );
  }
}

export class TripSelection {
  name: string;
  cards: CardContentSharryFragment[];
}
